// Third Party
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns'; 

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Services
import reminderService from '@/app/services/main/reminder/reminder-service.js';

// Constants
import { STATUS_CODES, SUCCESS_MSG, MEMBER_CLUB_GROUP_STATUS } from '@/app/constants/status-constants';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

export default {
    name: 'ModalAddEditReminder',
    components: {
        DatePicker
    },
    mixins: [ toastMessageMixins, dateMixins, userMixins ],
    data() {
        return {
            reminderDetails: {
                selectedType: '',
                otherType: 'Sample',
                note: '',
                schedule: '',
                selectedFrequency: ''
            },
            modalContent : {},
            saveButtonText: 'Add',
            reminderTypeOptions: [
                { id: 1, name: "Apply Treatment" },
                { id: 2, name: "Vet Appointment" },
                { id: 3, name: "Grooming Appointment" },
                { id: 4, name: "Sitting Appointment" },
                { id: 5, name: "Walking Appointment" },
                { id: 6, name: "Others" }
            ],
            isAPILoading: false,
            editReminderDetails: {}
        }
    },
    computed: {
        validationRules() {
			let fields = {
				reminderDetails: {
                    selectedType: {},
                    otherType: {},
                    schedule: {},
                    selectedFrequency: {}
				}
			}

			fields.reminderDetails = vuelidateUtil.setFieldsRequired(fields.reminderDetails, true);
			fields.reminderDetails = vuelidateUtil.setIsFutureDateAndTime(fields.reminderDetails, 'schedule');

			return fields;
        },
        isValid() {
            if (this.saveButtonText === 'Update') {
                if (this.modalContent.reminder.status === 'I') {
                    return !this.isChanged;
                }
                return  this.$v.$invalid || !this.isChanged;
            } else {
                return  this.$v.$invalid;
            }
        },
        isChanged() {
            let isChanged = false;

            if (this.reminderDetails.selectedType === 'Others') {
                isChanged = this.modalContent.reminder.type !== this.reminderDetails.otherType;
            } else {
                isChanged = this.modalContent.reminder.type !== this.reminderDetails.selectedType;
            }

            return isChanged || this.modalContent.reminder.note !== this.reminderDetails.note || this.modalContent.reminder.frequency !== this.reminderDetails.selectedFrequency || this.modalContent.reminder.schedule !== format(this.reminderDetails.schedule, 'yyyy-MM-dd HH:mm:ss').toString();
        },
        disabled() {
            return this.modalContent.reminder && this.modalContent.reminder.status === 'I';
        }
    },
    watch: {
        'reminderDetails.selectedType': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.reminderDetails.otherType = newVal === 'Others' ? this.editReminderDetails.type ? this.editReminderDetails.type : '' : 'Sample';
                    this.$v.reminderDetails.selectedType.$reset();
                    this.$v.reminderDetails.otherType.$reset();
                }
            },
            deep: true
        }
    },
    beforeDestroy() {
		this.hideModal();
	},
    methods: {
        show(content) {
            this.clearFields();
            this.modalContent = content;
            if (this.modalContent.reminder) {
                this.setFields(this.modalContent.reminder);
            }
			$(this.$refs.modalAddEditReminder).modal('show');
        },
        setFields(reminder) {
            if (reminder.note === null) {
                this.modalContent.reminder.note = '';
            }
            this.editReminderDetails = reminder;
            this.reminderDetails.selectedType = this.reminderTypeOptions.find(type => type.name === reminder.type) ?  reminder.type : 'Others'; 
            this.reminderDetails.note =  reminder.note;
            this.reminderDetails.selectedFrequency = reminder.frequency;
            this.reminderDetails.schedule = new Date(reminder.schedule);
            this.reminderDetails.otherType = this.reminderTypeOptions.find(type => type.name === reminder.type) ?  'sample' : reminder.type;
            this.saveButtonText = 'Update'
        },
        clearFields() {
			this.reminderDetails = {
                selectedType: '',
                otherType: 'Sample',
                note: '',
                schedule: '',
                selectedFrequency: ''
            }
            this.editReminderDetails = {};
            this.saveButtonText = 'Add';
			this.$v.$reset();
		},
		hideModal() {
			$(this.$refs.modalAddEditReminder).modal('hide');
        },
        refreshTable() {
            this.hideModal();
            this.$emit('getTableContent');
        },
        onBlur(field) {
			const { reminderDetails: { selectedType, schedule, selectedFrequency, otherType } } = this.$v;
			if (field === 'type') {
				selectedType.$touch();
			} else if (field === 'schedule') {
				schedule.$touch();
			} else if (field === 'frequency') {
				selectedFrequency.$touch();
			} else if (field === 'otherType') {
				otherType.$touch();
            }
        },
        onDoneReminder() {
            if (this.isValid) {
                return;
            }

            let requestBody = {
                petId: this.getActivePet.id,
                type: this.reminderDetails.selectedType === 'Others' ? this.reminderDetails.otherType : this.reminderDetails.selectedType,
                reminderDate: this.localizedDate(this.reminderDetails.schedule),
                frequency: this.reminderDetails.selectedFrequency
            }

            if (this.reminderDetails.note && this.reminderDetails.note !== '') {
                requestBody.note = this.reminderDetails.note;
            }

            if (this.saveButtonText === 'Add') {
                this.isAPILoading = true;

                reminderService.saveReminder(requestBody)
                    .then(res => {
                        const { ERROR_SAVE_REMINDER, SUCCESS_SAVE_REMINDER } = this.toastMessages.reminder();
                        if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_SAVE_REMINDER);
                            this.isAPILoading = false;

                            this.refreshTable();
                        } else {
                            this.isAPILoading = false;
                            this.showAPIErrorToast(ERROR_SAVE_REMINDER, res);
                        }
                    });
            } else {
                requestBody.isDateChanged = this.modalContent.reminder.schedule !== format(this.reminderDetails.schedule, 'yyyy-MM-dd HH:mm:ss').toString();

                this.isAPILoading = true;

                reminderService.updateReminder(this.modalContent.reminder.id, requestBody)
                    .then(res => {
                        const { ERROR_UPDATE_REMINDER, SUCCESS_UPDATE_REMINDER } = this.toastMessages.reminder();
                        if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_REMINDER);
                            this.isAPILoading = false;

                            this.refreshTable();
                        } else {
                            this.isAPILoading = false;
                            this.showAPIErrorToast(ERROR_UPDATE_REMINDER, res);
                        }
                    });
            }
        },
        stopReminder() {
            this.$swal({
				imageHeight: '30px',
				title: 'Are you sure you want to stop this reminder?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
			})
            .then(result => {
                if (result.value) {
                    reminderService.updateReminderStatus(this.modalContent.reminder.id, { status: MEMBER_CLUB_GROUP_STATUS.INACTIVE })
                    .then(res => {
                        const { ERROR_UPDATE_REMINDER, SUCCESS_UPDATE_REMINDER } = this.toastMessages.reminder();
                        if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_REMINDER);
                            this.isAPILoading = false;

                            this.refreshTable();
                        } else {
                            this.isAPILoading = false;
                            this.showAPIErrorToast(ERROR_UPDATE_REMINDER, res);
                        }
                    });
                }
            });
        }
    },
	validations() {
		return this.validationRules;
	}
}